import React, { useEffect, useState } from 'react';
const LINKS = [{
  label: 'Filosofi',
  href: '#filosofi'
}, {
  label: 'Tillfällen',
  href: '#tillfallen'
}, {
  label: 'Utbud',
  href: '#utbud'
}, {
  label: 'Verksamheter',
  href: '#verksamheter'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${scrolled ? 'bg-warm/90 backdrop-blur-md border-b border-brun/10' : 'bg-transparent'}`} data-id="element-106" data-mp="lzfrpgbqhqp">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10" data-id="element-107" data-mp="9mnu6l9mqk44">
        <a href="#top" className={`font-display text-lg tracking-tight transition-colors ${scrolled ? 'text-brun' : 'text-warm'}`} data-id="element-108" data-mp="1q0nongpphhjz">
          Smaken som Baken
        </a>

        <ul className={`hidden items-center gap-9 text-[13px] uppercase tracking-wide2 md:flex ${scrolled ? 'text-brun-soft' : 'text-warm/80'}`} data-id="element-109" data-mp="enap6pxi22g2">
          {LINKS.map(l => <li key={l.href} data-id="element-110" data-mp="om08mn51nuyf">
              <a href={l.href} className="transition-opacity hover:opacity-60" data-id="element-111" data-mp="ol8dfdfczz8o">
                {l.label}
              </a>
            </li>)}
        </ul>

        <a href="#verksamheter" className={`rounded-full border px-5 py-2 text-[12px] uppercase tracking-wide2 transition-colors ${scrolled ? 'border-brun/30 text-brun hover:bg-brun hover:text-warm' : 'border-warm/50 text-warm hover:bg-warm hover:text-brun'}`} data-id="element-112" data-mp="3s1ntzbtwd1sn">
          Utforska
        </a>
      </nav>
    </header>;
}